// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"71289d3a","346":"f8f5e1c9","734":"f059a598"}[chunkId] + ".chunk.js";
};